<!-- 头部-->
<template>
    <div v-if="navType != 'login'">
        <div class="whiteBg" style="z-index: 1001;position: relative;">
            <template v-if="navType == 'home'">
                <!-- 首页 -->
                <el-row :class="['wrapSection', 'linear', 'flex', 'navHeight', isShowMenu ? '' : 'borderMin']">
                    <el-col :xs="5" :sm="5" :md="5" :lg="11" :xl="11">
                        <div class="flex justify-content">
                            <img src="../../assets/images/logo.png" @click="indexJump" class="pointer" style="z-index: 1001;" />
                        </div>
                    </el-col>
                    <el-col :xs="19" :sm="19" :md="19" :lg="13" :xl="13">
                        <el-row>
                            <el-col :xs="12" :sm="12" :md="12" :lg="16" :xl="16">  
                                <div class="search-box">
                                    <el-input
                                        v-if="isShowSearch"
                                        type="text"
                                        :placeholder="$t('views.interest')"
                                        v-model="search"
                                        class="navSearch"
                                        @keyup.enter.native="searchEnter($event)"
                                    >
                                        <template #suffix>
                                            <div class="search-suffix" @click="handerSearch">
                                                <i class="el-icon-search"></i>
                                                <span>搜索</span>
                                            </div>
                                        </template>
                                    </el-input>
                                </div>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                                <div class="align-center" style="padding: 0 20px; box-sizing: border-box;">
                                    <div class="lang-box" style="padding-right: 10px; box-sizing: border-box;">
                                        <div class="flex">
                                            <img src="../../assets/images/lang.svg" class="headerImg" />
                                            <el-menu :default-active="activeIndex" class="buy-menu elMenuBtn" mode="horizontal">
                                                <el-submenu index="1">
                                                    <template slot="title">{{ curLangName }}</template>
                                                    <el-menu-item
                                                        v-for="(item,index) in langData"
                                                        :key="index"
                                                        :index="index.toString()"
                                                        class="minMenu"
                                                        @click="langChange(item)"
                                                    >
                                                        <span>{{item.title}}</span>
                                                    </el-menu-item>
                                                </el-submenu>
                                            </el-menu>
                                        </div>
                                    </div>
                                    <div class="log-box">
                                        <div class="flex">
                                            <template v-if="isLogin">
                                                <div class="loginBtn flex jcright" style="float:right">
                                                    <!-- 是否有头像 -->
                                                    <template v-if="imageUrl">
                                                        <img :src="imageUrl" />
                                                    </template>
                                                    <template v-else>
                                                        <img src="../../assets/images/tx.png" class="headerImg" />
                                                    </template>
                                                    <el-menu :default-active="activeIndex" class="buy-menu elMenuBtn" mode="horizontal">
                                                        <el-submenu index="2">
                                                            <template slot="title">
                                                                <span class="nowrap">{{ curLoginName }}</span>
                                                            </template>
                                                            <el-menu-item
                                                                v-for="(item,index) in selectBoxData"
                                                                :key="index"
                                                                :index="index.toString()"
                                                                class="minMenu"
                                                                @click="navJumpClick(item.path)"
                                                            >
                                                                <span>{{item.title}}</span>
                                                            </el-menu-item>
                                                        </el-submenu>
                                                    </el-menu>
                                                </div>
                                                <div class="action-btn">
                                                    <el-button type="primary" plain @click="publishChange">{{ $t('form.release') }}</el-button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="loginBtn flex">
                                                    <router-link to="/login" class="link-for">{{ $t('me.login') }}</router-link>
                                                    <router-link to="/register" class="link-item">{{ $t('login.register') }}</router-link>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <template v-if="isShowMenu">
                    <div class="bgColor">
                        <div class="section navWrap">
                            <span v-for="(item,index) in navList" :key="index" @click="menuClick(index,item)">
                                <i :class="{selected:index == isCurBg}">{{item.name}}</i>
                            </span>
                        </div> 
                    </div>
                </template>
            </template>
            <template v-else-if="navType == 'publish'">
                <!-- 发布页面 -->
                <div class="publishWrap">
                    <el-row style="padding: 30px 0;">
                        <el-col :span="16">
                            <div class="publishLogo">
                                <img src="../../assets/images/logo.png" @click="indexJump" class="pointer" style="z-index: 1001;" />
                                <span>{{ $t('views.release') }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemsRights flex">
                                <div class="loginBtn flex jcright" style="float:right">
                                    <!-- 是否有头像 -->
                                    <template v-if="imageUrl">
                                        <img :src="imageUrl" />
                                    </template>
                                    <template v-else>
                                        <img src="../../assets/images/tx.png" style="width:28px; height: 28px; display: inline-block;" />
                                    </template>
                                    <el-menu :default-active="activeIndex" class="buy-menu" mode="horizontal">
                                        <el-submenu index="4">
                                            <template slot="title">
                                                <span class="nowrap" style="max-width: 120px;">{{ curLoginName }}</span>
                                            </template>
                                            <el-menu-item
                                                v-for="(item,index) in selectBoxData"
                                                :key="index"
                                                :index="index.toString()"
                                                class="minMenu"
                                                @click="navJumpClick(item.path)"
                                            >
                                                <span>{{item.title}}</span>
                                            </el-menu-item>
                                        </el-submenu>
                                    </el-menu>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <template v-else-if="navType == 'login'">
                <!-- 登陆 -->
                <!-- <el-row class="flex navHeight lgoinsSection" style="z-index: 1000;">
                    <el-col :span="10">
                        <div class="logo flex justify-content">
                            <img src="../../assets/images/logo03.png" class="pointer" style="z-index: 1001;" @click="indexJump" />
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <div class="section navWrap logoTitWrap">
                            <span v-for="(item,index) in navList" :key="index" @click="menuClick(index,item)">
                                <i>{{item.categoryName}}</i>
                            </span>
                        </div>
                    </el-col>
                </el-row> -->
            </template>
            <template v-else-if="navType == 'other'">
                <!-- 其他页面 -->
                <el-row :class="['wrapSection','flex','navHeight', isShowMenu?'':'borderMin']" >
                    <el-col :span="1">
                        <div class="flex justify-content">
                            <img src="../../assets/images/logo.png" class="pointer" style="z-index: 1001;" @click="indexJump" />
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <!-- 导航栏 -->
                        <template v-if="isShowMenu">
                            <div class="navWrap2">
                                <span v-for="(item,index) in navList" :key="index" @click="menuClick(index,item)">
                                    <i :class="{selected:index == isCurBg}">{{item.name}}</i>
                                </span>
                            </div>
                        </template>
                    </el-col>
                    <el-col :span="11">
                        <el-row>
                            <el-col :xs="12" :sm="12" :md="12" :lg="14" :xl="14">  
                                <div class="search-box">
                                    <el-input
                                        v-if="isShowSearch"
                                        type="text"
                                        :placeholder="$t('views.interest')"
                                        v-model="search"
                                        class="navSearch2"
                                        @keyup.enter.native="searchEnter($event)"
                                    >
                                        <template #suffix>
                                            <div class="search-suffix" @click="handerSearch">
                                                <i class="el-icon-search"></i>
                                                <span>搜索</span>
                                            </div>
                                        </template>
                                    </el-input>
                                </div>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="12" :lg="10" :xl="10">
                                <div class="align-center" style="padding: 0 20px; box-sizing: border-box;">
                                    <div class="lang-box" style="padding-right: 10px; box-sizing: border-box;">
                                        <div class="flex">
                                            <img src="../../assets/images/map.png" class="headerImg" />
                                            <el-menu :default-active="activeIndex" class="buy-menu elMenuBtn" mode="horizontal">
                                                <el-submenu index="1">
                                                    <template slot="title">{{ curLangName }}</template>
                                                    <el-menu-item
                                                        v-for="(item,index) in langData"
                                                        :key="index"
                                                        :index="index.toString()"
                                                        class="minMenu"
                                                        @click="langChange(item)"
                                                    >
                                                        <span>{{item.title}}</span>
                                                    </el-menu-item>
                                                </el-submenu>
                                            </el-menu>
                                        </div>
                                    </div>
                                    <div class="log-box">
                                        <div class="flex">
                                            <template v-if="isLogin">
                                                <div class="loginBtn flex jcright" style="float:right">
                                                    <!-- 是否有头像 -->
                                                    <template v-if="imageUrl">
                                                        <img :src="imageUrl" />
                                                    </template>
                                                    <template v-else>
                                                        <img src="../../assets/images/tx.png" class="headerImg" />
                                                    </template>
                                                    <el-menu :default-active="activeIndex" class="buy-menu elMenuBtn" mode="horizontal">
                                                        <el-submenu index="2">
                                                            <template slot="title">
                                                                <span class="nowrap">{{ curLoginName }}</span>
                                                            </template>
                                                            <el-menu-item
                                                                v-for="(item,index) in selectBoxData"
                                                                :key="index"
                                                                :index="index.toString()"
                                                                class="minMenu"
                                                                @click="navJumpClick(item.path)"
                                                            >
                                                                <span>{{item.title}}</span>
                                                            </el-menu-item>
                                                        </el-submenu>
                                                    </el-menu>
                                                </div>
                                                <div class="action-btn">
                                                    <el-button type="primary" plain @click="publishChange">{{ $t('form.release') }}</el-button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="loginBtn flex">
                                                    <router-link to="/login" class="link-for">{{ $t('me.login') }}</router-link>
                                                    <router-link to="/register" class="link-item">{{ $t('login.register') }}</router-link>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </template>
            <!-- 弹窗发布 -->
            <PublishModal :visible="dialogVisible" @handleAction="handleAction"></PublishModal>
        </div>
    </div>
    <div v-else>
        <div class="logoBox">
            <img src="../../assets/images/logo03.png" class="pointer" style="z-index: 1001;" @click="indexJump" />
        </div>
    </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import PublishModal from "./publishModal"
  export default {
    name: '',
    components: {
        PublishModal
    },
    props: {
        navType: {
            type: String,
            default: ''
        },
        isShowMenu:{                //是否显示导航栏
            type: Boolean,
            default: true
        },
        isShowSearch:{              //是否显示搜索条
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            isCurBg:0,
            activeIndex: '1',
            search:'',
            selected:null,
            navList:[],
            langData: [
                {title: this.$t('views.zhCN') , type: 'zh-CN'},   //zh-CN'简体中文；zh-TW'繁体中文
                {title: this.$t('views.zhTW') , type: 'zh-TW'},
            ],
            selectBoxData:[         //登录之后的下拉导航
                {path:'/merchant',title: this.$t('views.centers') },
                {path:'/message',title: this.$t('views.menuItem') },
                {path:'/myInformation',title: this.$t('views.settingOption')},
                {path:'/changePassword',title: this.$t('views.actionButton')},
                {path:'/logOut',title: this.$t('me.logout')}
            ],
            names:'',               //姓名缩写
            columnType: 1,
            columnPath:null,
            childrenItem:[],
            curLangName: '',
            dialogVisible: false,
        }
    },
    computed: {
        ...mapState(['isOrLogin', 'userInfo']),
        // 计算属性获取登录状态和用户信息
        isLogin() {
            console.log(this.isOrLogin , this.userInfo, this.isOrLogin && this.userInfo)
            return this.isOrLogin && this.userInfo;
        },
        curLoginName() {
            return this.userInfo ? this.userInfo.nickName : '';
        },
        imageUrl() {
            if (this.userInfo && this.userInfo.headerPic) {
                return this.$global.baseUrl  + '/' + this.userInfo.headerPic;
            }
            return '';
        }
    },
    created() {
        // 语言
        const currentLang = this.$store.state.curLocale || 'zh-CN';
        const langItem = this.langData.find(item => item.type === currentLang);
        if (langItem) {
            this.curLangName = langItem.title;
        } else {
            this.curLangName = this.langData[0].title;
        }
	},
    mounted() {
        this.initData();
    },
    methods: {
        ...mapMutations(['SET_USER_INFO', 'CLEAR_USER_INFO']),

        /**
         * 路由操作处理
         */
        handleRoute(route) {
            const currentPath = route.path;
            const query = route.query;
            
            // 详情页面根据来源推断导航状态
            if (currentPath === '/newsPage' && query.from) {
                const fromNavMap = {
                    'hot': 1, 'news': 2, 'immigration': 3, 'estate': 4,
                    'finance': 5, 'auto': 6, 'funny': 7
                };
                if (fromNavMap[query.from]) {
                    this.isCurBg = fromNavMap[query.from];
                    localStorage.setItem('isCurBg', this.isCurBg);
                }
            } else if (currentPath === '/easyBookView') {
                this.isCurBg = 10;
                localStorage.setItem('isCurBg', 10);
            } else if (currentPath === '/merchantView') {
                this.isCurBg = 8;
                localStorage.setItem('isCurBg', 8);
            } else if (currentPath === '/recruitmentView') {
                this.isCurBg = 9;
                localStorage.setItem('isCurBg', 9);
            } else {
                // 原有的处理逻辑
                const navPaths = ['/index', '/newsIndex', '/merchantIndex', '/recruitmentIndex', '/easyBookIndex'];
                if (navPaths.includes(currentPath)) {
                    if (query.index !== undefined) {
                        this.isCurBg = parseInt(query.index);
                        localStorage.setItem('isCurBg', this.isCurBg);
                    } else {
                        const savedIndex = localStorage.getItem('isCurBg');
                        if (savedIndex !== null) this.isCurBg = parseInt(savedIndex);
                    }
                } else {
                    this.isCurBg = 0;
                    localStorage.setItem('isCurBg', 0);
                }
            }
            
            this.showName();
            this.$forceUpdate();
        },
        /**
         * 搜索
         */
        handerSearch() {
            let that = this;
            if (!this.search) {
				this.$message.warning(this.$t('me.keywords'));
                return;
            }
            this.$router.push({
                name: 'search',
                params:{'keyword':that.search}
            });
		},
        /**
         * 回车搜索
         */
        searchEnter(e) {
            if (!this.search) {
				this.$message.warning(this.$t('me.keywords'));
                return;
            }
            var keyCode = window.event? e.keyCode:e.which;
			if (keyCode == 13 && this.search) {
                this.$router.push({
                    name: 'search',
                    params:{'keyword': this.search}
                });
                this.search = '';
			}
        },
        /**
         * 加载导航栏
         */
        initData() {
            const defaultNavItems = [
                { name: this.$t('index.life'), id: 'd8', path: '/merchantIndex' },
                { name: this.$t('index.recruit'), id: 'd9', path: '/recruitmentIndex' },
                { name: this.$t('index.youknow'), id: 'd10', path: '/easyBookIndex' }
            ];
            // 栏目类别:1首页;2:生活;3:招聘;4:知否
            let columnType = this.columnType;
            this.$ajax.get(this.$api.index.columnTree, {columnType: columnType}).then((res) => {
                if(res.code === 200) {
                    let arr = res.data;
                    // 为每个导航项添加 path 地址
                    arr = arr.map(item => {
                        item.path = '/newsIndex';
                        return item;
                    });
                    let obj = { name: this.$t('index.home'), id: '0', path: '/index' };
                    arr.unshift(obj);
                    this.navList = [...arr, ...defaultNavItems];
                    this.columnPath = this.navList[0].id;
					this.childrenItem = this.navList[0].children;
                } else {
                    // 使用默认数据（包含首页）
                    this.navList = [{ name: this.$t('index.home'), id: '0' }, ...defaultNavItems];
                    this.$message.warning(res.msg);
                }
            }).catch((error) => {
            });
        },
        /**
         * 点击跳转
         */
        // 在跳转时确保传递正确的参数
        menuClick(index, item) {
            this.isCurBg = index; 
            localStorage.setItem('isCurBg', index);
            let queryItem = {};
            if (item.id == 0) {
                queryItem = {'index': 0}
            } else {
                queryItem = {
                    'channelId': item.id, 
                    'index': index,
                    'from': this.getFromParamByIndex(index) // 添加from参数作为备用
                }
            }
            this.$router.push({
                path: item.path,
                query: queryItem
            });
        },
        // 根据index获取对应的from参数
        getFromParamByIndex(index) {
            const fromMap = {
                1: 'hot', 2: 'news', 3: 'immigration', 4: 'estate',
                5: 'finance', 6: 'auto', 7: 'funny',
                8: 'merchant', 9: 'recruitment', 10: 'easybook'
            };
            return fromMap[index] || 'news';
        },
        langChange(item) {
            this.curLangName = item.title;
            localStorage.setItem("language", item.type);
            this.$store.commit('CURLOCALE', item.type);
            if (this.$i18n) {
                this.$i18n.locale = item.type;
            }
            location.reload();
        },
        /**
         * 点击登录之后的下拉导航
         */
        navJumpClick(path) {
            // 重置导航菜单选中状态
            this.isCurBg = '';
            localStorage.setItem('isCurBg', '');
            if(path == '/logOut'){
                this.confirmLogout();
            }else{
                this.$router.push({
                    path: path
                })
            }
        },
        /**
         * 确定退出 
         */
        confirmLogout() {
            this.$confirm(this.$t('views.outlogin'), this.$t('views.youknowTip'), {
                confirmButtonText: this.$t('upload.verify'),
                cancelButtonText: this.$t('upload.cancel'),
                type: 'warning'
            }).then(() => {
                this.stuLogout();
            }).catch(() => {
            });
        },
        /**
         * 退出登录
         */
        stuLogout() {
            this.$ajax.get(this.$api.login.logout, {}).then(ret => {
                if (ret.code != 200) {
                    this.$message({message: "退出登录失败，" + res.msg, type: 'error'});
                    return;
                }
                // 清除 Vuex 状态
                this.CLEAR_USER_INFO();
                this.isCurBg = 0; 
                localStorage.setItem('isCurBg', 0);
                this.$router.push({
                    path:'/index',
                    query:{'index': 0}
                });

                // 刷新当前页面
                window.location.reload();
            })
            .catch(err => {
                this.$message({message: "退出登录失败！", type: 'error'});
            });
        },
        /**
         * 跳转到首页
         */
        indexJump(){
            this.isCurBg = 0;
            localStorage.setItem('isCurBg', 0);
            this.$router.push({
                path: '/index',
                query:{'index':0}
            });
        },
        publishChange() {
            this.dialogVisible = true;
        },
        handleAction(e) {
            this.dialogVisible = false;
        },
    }
  }
</script>
<style scoped>
    .logo > img {
        width: 90px;
        cursor: pointer;
        margin-left: 10%;
        margin-top: 50px;
    }
    .logo > span{
        font-size: 13px;
        color: #000;
        padding-right: 25px;
        box-sizing: border-box;
    }
    .loginBtn{
        height: 40px;
        line-height: 40px;
    }
    .loginBtn > img{
        cursor: pointer;
        width: 28px;
        display: inline-block;
        height: 28px;
        border-radius: 50%;
    }
    .loginBtn > span{
        cursor: pointer;
        color: #05131c;
        font-size: 13px;
        font-weight: bold;
        padding-left: 10px;
    }
    .navHeight {
        padding-top: 20px;
        padding-bottom: 20px;
        /* z-index: 1001;
        position: relative; */
    }
    .navWrap > span{
        display: inline-block;
    }
    .navWrap i{
        color: #fff;
        font-size: 16px;
        padding: 18px 25px;
        display: inline-block;
        cursor: pointer;
    }
    .navWrap i.selected{
        color: #fff;
        background-color: #710d12;
        border-radius: 5px;
    }
    .navWrap2 {
        padding-left: 30px;
    }
    .navWrap2 > span{
        display: inline-block;
    }
    .navWrap2 i{
        color: #333;
        font-size: 16px;
        padding: 20px 21px;
        display: inline-block;
        cursor: pointer;
    }
    .navWrap2 i.selected{
        color: #000;
        font-weight: bold;
        position: relative;
    }
    .navWrap2 i.selected::after {
        content: '';
        position: absolute;
        bottom: 8px;
        left: 50%;
        transform: translate(-50%);
        width: 20px;
        height: 3px;
        background-color: #90080E;
    }
    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .buy-menu.el-menu .el-submenu__title {
        color: #333;
    }
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: none !important;
    }
    .buy-box{
        font-size: 24px;
        margin-right: 50px;
        color: #666;
    }
    .item{
        cursor: pointer;
    }
    .lyIcon-min{
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
    }
    .logo > span.logoTit{
        color: #f7fbff !important;
    }
    .logoTitWrap i{
        color: #fff !important;
    }
    .section.flex.navHeight.lgoinsSection{
        position: absolute;
        transform: translate(-50%,0);
        left: 50%;
    }
    .borderMin{
        border-bottom: 1px solid #f5f5f5;
    }
    .itemsLefts{
        width: 100%;
        padding-right: 56px;
        box-sizing: border-box;
        float: right;
    }
    .itemsRights{
        float:right
    }
    .wrapSection {
        padding: 30px 80px;
    }
    /* 2K屏幕 (≥2560px) */
    @media screen and (min-width: 2560px) {
        .wrapSection {
            padding-left: calc((100vw - 2400px) / 2) !important;
            padding-right: calc((100vw - 2400px) / 2) !important;
            max-width: 2400px;
            margin: 0 auto;
        }
    }
    /* 4K屏幕 (≥3840px) */
    @media screen and (min-width: 3840px) {
        .wrapSection {
            padding-left: calc((100vw - 3200px) / 2) !important;
            padding-right: calc((100vw - 3200px) / 2) !important;
            max-width: 3200px;
        }
    }
    .linear {
        background: transparent linear-gradient(90deg, #90080E00 0%, #90080E12 70%) 0% 0% no-repeat padding-box;
    }
    .link-for {
        color: #90080E;
        border-radius: 20px;
        border: 1px solid #90080E;
        /* padding: 0 22px; */
        font-weight: bold;
        font-size: 14px;
        margin-right: 15px;
        width: 74px;
        text-align: center;
    }
    .link-item {
        color: #fff;
        border-radius: 30px;
        border: 1px solid #90080E;
        /* padding: 0 25px; */
        font-weight: bold;
        font-size: 14px;
        background-color: #90080E;
        width: 74px;
        text-align: center;
    }
    .action-btn {
        padding-left: 20px;
    }
    .action-btn .el-button {
        border-radius: 20px;
        padding: 13px 25px;
        font-size: 14px;
        transition: all 0.3s ease;
        color: #fff ;
        background-color: #90080E;
    }
    .action-btn .el-button:hover {
        background-color: #90080E;
        border-color: #90080E;
    }
    .headerImg {
        width: 28px;
        height: 28px;
        display: inline-block;

        margin-left: 10px;
    }
    .publishLogo {
        margin-right: 30px;
        display: flex;
        align-items: center;
    }
    .publishLogo > span {
        font-size: 20px;
        color: #000;
        margin-left: 30px;
    }
    .nowrap {
        max-width: 100px;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .search-box {
        /* width: 66%; */
        /* width: 626px; */
        /* display: inline-block; */
        /* padding-right: 56px; */
        /* box-sizing: border-box; */
    }
    .lang-box {
        /* width: 16%; */
        /* width: 152px; */
        /* display: inline-block;
        padding-right: 27px;
        box-sizing: border-box; */
    }
    .log-box {
        /* width: 18%; */
        /* width: 170px; */
        /* display: inline-block; */
    }
    .search-suffix {
        margin: 10px 20px;
        padding-left: 15px;
        display: flex;
        align-items: center;
        border-left: 1px solid #9999994d;
        color: #333;
        cursor: pointer;
        font-size: 15px;
    }
    .search-suffix > i {
        cursor: pointer;
        margin-right: 8px;
        font-size: 17px;
    }

    .logoBox {
        position: absolute;
        top: 70px;
        left: 80px;
        z-index: 9999;
    }
    .logoBox > img {
        width: 90px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/NavBar/index.vue